import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Link } from 'react-router-dom';

export const gameList = [
    {
        link: "/mine",
        name: 'Mine'
    },
    {
        link: "/slide",
        name: "Slide"
    },
    {
        link: "/video-poker",
        name: "VideoPoker"
    },
    {
        link: "/crash",
        name: "Crash"
    },
    {
        link: "/baccarat",
        name: "Baccarat(Multiplayer)"
    },
    {
        link: "/hilo",
        name: "Hilo"
    },
    {
        link: "/goal",
        name: "Goal"
    },
    {
        link: "/blackjack",
        name: "Blackjack"
    },
    // {
    //     link: "/roulette",
    //     name: "Roulette"
    // },
    // {
    //     link: "/baccarat-single",
    //     name: "Baccarat"
    // },
    // {
    //     link: "/hilo-multiplayer",
    //     name: "Hilo(Multiplayer)"
    // }
]

function Layout() {

    const menuref = useRef<any>(null);

    const [auth, setAuth] = React.useState(true);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (menuref.current && !menuref.current?.contains(event.target)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])

    return (
        <div>
            <header className='z-50'>
                <nav className="bg-[#1a2c38] shadow-custom-dark">
                    <div className="flex items-center justify-between p-4">
                        <div className="flex items-center">
                            <button className="text-white mr-2" aria-label="menu">
                                <svg
                                    className="w-8 h-8"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M4 6h16M4 12h16m-7 6h7"
                                    />
                                </svg>
                            </button>
                            <h1 className="text-white text-lg"></h1>
                        </div>
                        <div className="text-white font-semibold bg-[#0f1b24] border border-inputborader px-3 py-2 rounded-md shadow-sm">
                            Balance: {useSelector((state: any) => state?.auth?.balance ?? 0).toFixed(2)} USD
                        </div>
                        {auth && (
                            <div className='relative' ref={menuref}>
                                <button
                                    className="text-white"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleMenu}
                                >
                                    <svg
                                        className="w-8 h-8"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M5.121 17.804A8.988 8.988 0 0112 15c2.486 0 4.735.99 6.879 2.804m-6.879 1.196a4.5 4.5 0 10-4.5-4.5 4.5 4.5 0 004.5 4.5z"
                                        />
                                    </svg>{" "}
                                </button>
                                {anchorEl && (
                                    <div
                                        id="menu-appbar"
                                        onClick={handleClose}
                                        className="absolute z-50 right-0 mt-2 w-48 bg-white shadow-lg origin-top-right rounded-sm"
                                    >
                                        <ul className="py-1 w-full" role="menu">
                                            {
                                                gameList.map((item, index) => {
                                                    return <li className='p-1 hover:bg-slate-500 transition-all duration-150 w-full' key={index}><Link to={item.link} className='w-full'><div className='w-full'>{item.name}</div></Link></li>
                                                })
                                            }
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </nav>
            </header>
            <main>
                {/* The Outlet component will render the matched child route */}
                <Outlet />
            </main>
            <footer>
                <p>© 2024 My Website</p>
            </footer>
        </div>
    );
}

export default Layout;
